const JAIN_STATIC_ROUTE_PATTERNS = [
  /^\/$/,
  /^\/browse\/?$/,
  /^\/contribute\/?$/,
  /^\/search\/?$/,
  /^\/term\/[^/]+\/?$/,
  /^\/login\/?$/,
  /^\/jlx-vault-entry\/?$/,
  /^\/forgot-password\/?$/,
  /^\/staff-forgot-password\/?$/,
  /^\/account\/?$/,
  /^\/admin(\/.*)?$/,
  /^\/scope-of-work\/?$/,
];

export const isJainStaticRoute = (pathname: string) =>
  JAIN_STATIC_ROUTE_PATTERNS.some(pattern => pattern.test(pathname));

export const getLegacyJainRedirectPath = (pathname: string) => {
  const legacyJainPathMatch = pathname.match(/^\/[^/]+\/jainlexicon(\/.*)?$/);
  if (!legacyJainPathMatch) {
    return null;
  }
  return legacyJainPathMatch[1] || "/";
};
